
import { Injectable, OnDestroy } from '@angular/core';
import { Theme } from '../themes/theme.model';
import { tunisia, lonaci } from '../themes/theme';
import { StorageService } from '../providers/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { OfferedLanguage } from '../interfaces/language.model';
import { defaultLanguages } from '../constants/languages.constant';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class SkeletonServiceService implements OnDestroy {

  private _minHeight: any;
  private _minWidth: any;
  private _mobileBreak: number = 850;
  private _maxHeight: any;
  private _maxWidth: any;
  private _activeheaderClass: any;
  private _viewInContext: any;
  private _theme: Theme = lonaci;
  private _currentTime = new Date();
  private _activeHeader: any;
  appLanguage$: BehaviorSubject<OfferedLanguage> = new BehaviorSubject(null);
  private subscription: Subscription = new Subscription();
  private channelSubject = new BehaviorSubject<number>(3);
  channel$ = this.channelSubject.asObservable();
  public get activeHeader(): any {
    return this._activeHeader;
  }
  public set activeHeader(value: any) {
    this._activeHeader = value;
  }

  public get mobileBreak(){
    return this._mobileBreak;
  }


  public get currentTime() {
    return this._currentTime;
  }
  public set currentTime(value) {
    this._currentTime = value;
  }

  public get theme(): Theme {
    return this._theme;
  }
  public set theme(value: Theme) {
    this._theme = value;
  }
  public get viewInContext(): any {
    return this._viewInContext;
  }
  public set viewInContext(value: any) {
    this._viewInContext = value;
  }

  public get activeheaderClass(): any {
    return this._activeheaderClass;
  }
  public set activeheaderClass(value: any) {
    this._activeheaderClass = value;
  }


  public get minHeight(): any {
    return this._minHeight;
  }
  public set minHeight(value: any) {
    this._minHeight = value;
  }
  public get minWidth(): any {
    return this._minWidth;
  }
  public set minWidth(value: any) {
    this._minWidth = value;
  }

  public get maxHeight(): any {
    return this._maxHeight;
  }
  public set maxHeight(value: any) {
    this._maxHeight = value;
  }

  public get maxWidth(): any {
    return this._maxWidth;
  }
  public set maxWidth(value: any) {
    this._maxWidth = value;
  }


  constructor(
    private storage: StorageService,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService
  ) {
    this.subscription = this.breakpointObserver
      .observe([`(max-width: ${this.mobileBreak}px)`])
      .subscribe(result => {
        this.channelSubject.next(result.matches ? 7 : 3);
      });
  }


  public isApk() {
    return navigator.userAgent.includes('android-lonaci');
  }

  public isMobile() {
    // const arch = /Android|android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Kindle|Silk-Accelerated|(hpw|web)OS/i.test(navigator.userAgent)

    const result = (window.innerWidth <= this._mobileBreak);

    return result;
  }

  public isAndroid(){
    return /Android|android/i.test(navigator.userAgent);
  }

  public isIOS(){
    return /iPad|iPhone|iPod|Mac/.test(navigator.userAgent) ;
  }

  getMobileOS() {
    const ua = navigator.userAgent
    if (/Android Native/i.test(ua))
      return "Android_Native";

    if (/android/i.test(ua)) {
      return "Android"
    }

    if (/iPad|iPhone|iPod/.test(ua) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return "iOS"
    }

    return "Other"
  }

  scrollToStart(id){
    const newTab = document.getElementById(id);
      newTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
  }

  copyText(couponCode) {
    return;
    /* const pending = this.clipboard.beginCopy(couponCode);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        // Remember to destroy when you're done!
        pending.destroy();
      }
    };
    attempt(); */
  }

  toggleDropdown(targetId, togglerId?) {
    var target = document.getElementById(targetId);
    var toggler = document.getElementById(togglerId);
    // console.log("start", toggler, target);

    if (target && target.classList.contains('show')) {
      // console.log("showing: ", target);

      if (toggler && !toggler.classList.contains('collapsed')) {

        document.getElementById(togglerId).classList.add('collapsed');

      }

      document.getElementById(targetId).classList.remove('show');
      document.getElementById(targetId).classList.add('hide');

    } else {

      if (target.classList.contains('hide')) {
        if (toggler && toggler.classList.contains('collapsed')) {
          document.getElementById(togglerId).classList.remove('collapsed');
        }

      }

      document.getElementById(targetId).classList.remove('hide');
      document.getElementById(targetId).classList.add('show');
    }
  }

  changeAppLanguage(langCode: string){
    const language = defaultLanguages.find(lang => lang.code === langCode)
    this.translate.use(langCode.toLowerCase());
    this.appLanguage$.next(language);
    this.storage.save('lang', langCode);
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }

}
